import { IconLink } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import type { UTMICampaign as UTMType } from 'typings'
import { useFormStateContext } from '../../../../providers'
import { useDrawerState } from '../../../Drawer'
import { useConditions } from '../useConditions'
import { Editor } from './Editor'
import { View } from './View'
import { messages } from './messages'

type Props = {
  name: string
}

export type DrawerFormType = UTMType

export function UTMICampaign(props: Props) {
  const { $t } = useIntl()
  const { name } = props
  const { form } = useFormStateContext()
  const config: UTMType | undefined = useWatch({ form, name })
  const editorState = useDrawerState()

  const handleRemove = () => {
    form.setValue(name, undefined)
  }

  const handleSave = (values: DrawerFormType) => {
    const hasUtms = !!values.utmiCampaign.length

    form.setValue(name, hasUtms ? values : undefined)
  }

  const initialEditorConfig = useMemo<UTMType>(
    () => config ?? { utmiCampaign: [] },
    [config]
  )

  useConditions({
    name,
    icon: <IconLink />,
    onEdit: editorState.show,
    label: $t(messages.title),
  })

  return (
    <>
      <View onEdit={editorState.show} onRemove={handleRemove} values={config} />
      <Editor
        state={editorState}
        initialConfig={initialEditorConfig}
        onSave={handleSave}
      />
    </>
  )
}
